import { Cursor } from '../components/common';

/**
 * Neutral shell prerendered to `dist/shell.html` and served as the SPA fallback
 * (see `public/_redirects` and the PWA `navigateFallback` in `vite.config.ts`).
 *
 * Routes that aren't prerendered are served this markup, so it must stay free of
 * page-specific content — otherwise that content flashes before the router
 * resolves the real route.
 */
export function AppShell() {
  return (
    <div className="flex-1 flex items-center justify-center bg-base-200 p-6">
      <Cursor size="lg" label="Loading" />
    </div>
  );
}
